(function () {
  function initSalesSection(root) {
    if (!root || root.dataset.vsReady === 'true') return;

    root.dataset.vsReady = 'true';

    var routeRoot = root.dataset.rootUrl || '/';
    var buySuffix = root.dataset.buySuffix || 'in den Warenkorb';
    var mobileBuyLabel = root.dataset.mobileBuyLabel || 'In den Warenkorb';
    var unavailableLabel = root.dataset.unavailableLabel || 'Derzeit nicht verfügbar';
    var planButtons = Array.prototype.slice.call(root.querySelectorAll('[data-vs-variant]'));
    var buyButtons = Array.prototype.slice.call(
      root.querySelectorAll('[data-vs-buy], [data-vs-mobile-buy]')
    );
    var shippingBoxes = Array.prototype.slice.call(root.querySelectorAll('[data-vs-shipping]'));
    var mobileBar = root.querySelector('[data-vs-mobile-bar]');
    var mobilePlanLabel = root.querySelector('[data-vs-mobile-label]');
    var mobilePrice = root.querySelector('[data-vs-mobile-price]');
    var topBuybox = root.querySelector('.vs-sales-buybox--hero');
    var finalBuybox = root.querySelector('#vs-purchase-bottom');

    if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/';

    function findAvailableButton() {
      return planButtons.find(function (button) {
        return !button.disabled && button.getAttribute('aria-disabled') !== 'true';
      });
    }

    function getPlanLabel(variantId) {
      var matchingButton = planButtons.find(function (button) {
        return button.dataset.vsVariant === String(variantId);
      });

      return matchingButton ? matchingButton.dataset.vsPlanLabel : '';
    }

    function updateShipping(packCount) {
      shippingBoxes.forEach(function (shippingBox) {
        var freeFrom = Number(shippingBox.dataset.freeFrom || 0);
        var isFree = freeFrom > 0 && Number(packCount) >= freeFrom;
        var freeLabels = Array.prototype.slice.call(
          shippingBox.querySelectorAll('[data-vs-shipping-free]')
        );

        shippingBox.classList.toggle('is-free', isFree);

        freeLabels.forEach(function (label) {
          label.hidden = !isFree;
        });
      });
    }

    function selectVariant(variantId) {
      var selectedId = String(variantId);
      var selectedButton = planButtons.find(function (button) {
        return button.dataset.vsVariant === selectedId && !button.disabled;
      });

      if (!selectedButton) selectedButton = findAvailableButton();

      if (!selectedButton) {
        buyButtons.forEach(function (button) {
          button.removeAttribute('href');
          button.textContent = unavailableLabel;
          button.classList.add('is-disabled');
          button.setAttribute('aria-disabled', 'true');
        });
        return;
      }

      selectedId = selectedButton.dataset.vsVariant;

      planButtons.forEach(function (button) {
        var isSelected = button.dataset.vsVariant === selectedId;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      var planLabel = getPlanLabel(selectedId);

      buyButtons.forEach(function (button) {
        button.href = routeRoot + 'cart/' + selectedId + ':1';
        button.textContent = button.hasAttribute('data-vs-mobile-buy')
          ? mobileBuyLabel
          : (planLabel + ' ' + buySuffix).trim();
        button.classList.remove('is-disabled');
        button.removeAttribute('aria-disabled');
      });

      if (mobilePlanLabel) {
        mobilePlanLabel.textContent = planLabel;
      }

      if (mobilePrice) {
        mobilePrice.textContent = selectedButton.dataset.vsPrice || '';
      }

      updateShipping(selectedButton.dataset.vsPackCount || '1');
    }

    planButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!button.disabled) selectVariant(button.dataset.vsVariant);
      });
    });

    var initiallySelected = planButtons.find(function (button) {
      return button.classList.contains('is-selected') && !button.disabled;
    });

    selectVariant(initiallySelected ? initiallySelected.dataset.vsVariant : '');

    if (mobileBar && topBuybox) {
      var updateQueued = false;

      function updateMobileBar() {
        updateQueued = false;

        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var topBounds = topBuybox.getBoundingClientRect();
        var finalBounds = finalBuybox ? finalBuybox.getBoundingClientRect() : null;
        var topHasPassed = topBounds.bottom <= 0;
        var finalIsVisible = finalBounds
          ? finalBounds.top < window.innerHeight && finalBounds.bottom > 0
          : false;
        var shouldShow = isMobile && topHasPassed && !finalIsVisible;

        mobileBar.hidden = !shouldShow;
        mobileBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      function queueMobileBarUpdate() {
        if (updateQueued) return;

        updateQueued = true;
        window.requestAnimationFrame(updateMobileBar);
      }

      window.addEventListener('scroll', queueMobileBarUpdate, { passive: true });
      window.addEventListener('resize', queueMobileBarUpdate);
      updateMobileBar();
    }
  }

  function initAllSalesSections(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-vs-sales]')) initSalesSection(context);

    context.querySelectorAll('[data-vs-sales]').forEach(initSalesSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSalesSections(document);
    });
  } else {
    initAllSalesSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllSalesSections(event.target);
  });
})();